import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SapSocialStarterAnglePublishData,
	type SapSocialStarterAnglePublishDataQuery,
	type SapSocialStarterAnglePublishDataQueryVariables,
} from './socialStarterAngleSourceLocation.graphql';

/**
 * Best-effort lookup of the Social Starter data needed when publishing. Returns null on any
 * miss/error so the caller can preserve the existing non-Social-Starter publish behavior.
 */
export async function fetchSocialStarterAnglePublishData({
	token,
	utilityContext,
}: {
	token: string;
	utilityContext: UtilityContext;
}): Promise<Readonly<{ sourceLocation: string | null; decisionMakerId: string | null }> | null> {
	try {
		const { data } = await utilityContext.gql.fetch<
			SapSocialStarterAnglePublishDataQuery,
			SapSocialStarterAnglePublishDataQueryVariables
		>({
			query: SapSocialStarterAnglePublishData,
			variables: { token },
			rejectOnError: true,
		});

		if (!data.socialStarterPetitionAnglesByToken.success) return null;
		return {
			sourceLocation: data.socialStarterPetitionAnglesByToken.metadata?.sourceLocation ?? null,
			decisionMakerId: data.socialStarterPetitionAnglesByToken.decisionMaker?.id ?? null,
		};
	} catch (error) {
		void utilityContext.errorReporter.report({
			error: error instanceof Error ? error : new Error('Failed to load Social Starter publish data', { cause: error }),
		});
		return null;
	}
}
